import {formatter, request} from '@/utils/request';

export namespace SoldTo {
  export const Path = {
    Get: '/expenseapi/soldTo/get',
    Search: '/expenseapi/soldTo/search',
    AjaxSearch: '/expenseapi/soldTo/ajaxSearch',
    SearchAll: '/expenseapi/soldTo/searchAll',
    AjaxSearchAll: '/expenseapi/soldTo/ajaxSearchAll',
    SearchForSp: '/expenseapi/soldTo/searchForSp',
    GetEx: '/expenseapi/soldTo/getEx',
    Query: '/expenseapi/soldTo/query',
    Export: '/expenseapi/soldTo/export',
    Post: '/expenseapi/soldTo/post',

    QueryForSheet: '/expenseapi/soldTo/queryForSheet',
    SimpleQueryForSheet: '/expenseapi/soldTo/simpleQueryForSheet',
    QueryForSoldToTargetSheet: '/expenseapi/soldTo/queryForSoldToTargetSheet',
  };

  export async function get(id: string) {
    const options = {
      method: 'GET',
      body: {
        code: id,
      },
    };
    return request<API.ResponseResult<API.SoldTo>>(Path.Get, formatter(options));
  }

  export async function search(body: API.SoldToSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldTo[]>>(Path.Search, formatter(options));
  }

  export async function ajaxSearch(body: API.SoldToSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldTo[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function searchAll(body: API.SoldToSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldTo[]>>(Path.SearchAll, formatter(options));
  }

  export async function ajaxSearchAll(body: API.SoldToSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldTo[]>>(Path.AjaxSearchAll, formatter(options));
  }

  export async function searchForSp(body: API.SoldToSearchForSpParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldTo[]>>(Path.SearchForSp, formatter(options));
  }

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.SoldToQuery[]>>(Path.Query, formatter(options));
  }

  export async function getEx(id: string) {
    const options = {
      method: 'GET',
      body: {
        code: id,
      },
    };
    return request<API.ResponseResult<API.SoldToQuery>>(Path.GetEx, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldToQuery[]>>(Path.Export, formatter(options));
  }

  export async function post(body: API.SoldToEditParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldTo>>(Path.Post, formatter(options));
  }

  export async function queryForSheet(body: API.SoldToSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any[]>>(Path.QueryForSheet, formatter(options));
  }

  export async function simpleQueryForSheet(body: API.SoldToSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any[]>>(Path.SimpleQueryForSheet, formatter(options));
  }

  export async function queryForSoldToTargetSheet(body: API.SoldToSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any[]>>(Path.QueryForSoldToTargetSheet, formatter(options));
  }
}
